import { render, staticRenderFns } from "./leaderBoard.vue?vue&type=template&id=fabb2172&scoped=true"
import script from "./leaderBoard.vue?vue&type=script&lang=js"
export * from "./leaderBoard.vue?vue&type=script&lang=js"
import style0 from "./leaderBoard.vue?vue&type=style&index=0&id=fabb2172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabb2172",
  null
  
)

export default component.exports